import { isGatewayPlutusLawsys } from "./functions";
import { UK_ADDRESS_PART_1, UK_LEI_ADDRESS_PART_1 } from "./constants";

const LEI_BANK_POSITIONS = {
    BANK_NAME: "AdvanceDisbursementsStatementLeiBankName",
    BANK_ACCOUNT_NAME: "AdvanceDisbursementsStatementLeiAccountName",
    BANK_SORT_CODE: "AdvanceDisbursementsStatementLeiSortCode",
    BACK_ACCOUNT_NUMBER: "AdvanceDisbursementsStatementLeiAccountNumber"
};

const PLC_BANK_POSITIONS = {
    BANK_NAME: "AdvanceDisbursementsStatementBankName",
    BANK_ACCOUNT_NAME: "AdvanceDisbursementsStatementAccountName",
    BANK_SORT_CODE: "AdvanceDisbursementsStatementSortCode",
    BACK_ACCOUNT_NUMBER: "AdvanceDisbursementsStatementAccountNumber"
};

// WI 100256. The legal entity belongs to the firm, not to the disbursements a statement happens to list -
// so a GPL firm with nothing due still issues an ARAG LEI statement. A policy's own statement uses its
// SystemsOfRecordId with isGatewayPlutusLawsys directly.
// A firm never holds both: its plc policies are transferred out before its provider is flipped to LEI.
export const isGplFirm = (firm) => isGatewayPlutusLawsys(firm?.aragProvider?.defaultSystemsOfRecordId);

// All four ARAG LEI bank rows or none, and the address block follows the same answer. Naming one legal
// entity beside another entity's account number is a payment instruction nobody can safely act on, so an
// unseeded LEI falls back to ARAG plc whole rather than per field.
//
// Not gated by the EMAIL_FOOTER_LEGAL_ENTITY_ENABLED go-live switch (WI 102222): a GPL statement names the
// LEI whatever the switch says, same as the backend's AragLegalEntityText.
export const getADStatementLegalEntity = (adStatementMessages, isGpl) => {
    const body = (position) => getADStatementMessageBodyFromPosition(adStatementMessages, position);
    const isLei = !!isGpl
        && Object.values(LEI_BANK_POSITIONS).every(position => !!body(position));
    const bank = isLei ? LEI_BANK_POSITIONS : PLC_BANK_POSITIONS;

    return {
        isLei,
        legalEntityName: isLei ? UK_LEI_ADDRESS_PART_1 : UK_ADDRESS_PART_1,
        statementMessages: {
            BANK_NAME: body(bank.BANK_NAME),
            BANK_ACCOUNT_NAME: body(bank.BANK_ACCOUNT_NAME),
            BANK_SORT_CODE: body(bank.BANK_SORT_CODE),
            BACK_ACCOUNT_NUMBER: body(bank.BACK_ACCOUNT_NUMBER),
            COMMENTS_OR_SPECIAL_INSTRUCTIONS: body("AdvanceDisbursementsStatementCommentsOrSpecialInstructions"),
            BANK_MESSAGE: body("AdvanceDisbursementsStatementBankMessage")
        }
    };
};

export const getADStatementMessageBodyFromPosition = (adStatementMessages, position) => {
    const found = adStatementMessages.find(i => i.position === position);
    if(found){
        return found.body;
    }

    return "";
};
